module.exports = "<div class=oui-tooltip role=tooltip ng-bind=$tooltipCtrl.text></div> ";